import { GuardrailsEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const createPackage = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_PACKAGE, data, true, {}, {}, axios);

const getAllGuardRail = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_ALL_PACAKGES, true, {}, {}, axios);

const updatePackage = async (id: string, data: any): Promise<any> =>
  APIManager.sendPatch(
    GuardrailsEnds.UPDATE_PACKAGE(id),
    data,
    true,
    {},
    {},
    axios
  );

const deletePackage = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_PACKAGE(id), true, {}, {}, axios);

const getAllGuardrailsPolicy = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_ALL_POLICIES, true, {}, {}, axios);

const createPolicy = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_POLICY, data, true, {}, {}, axios);

const updatePolicy = async (id: string, data: any): Promise<any> =>
  APIManager.sendPatch(
    GuardrailsEnds.UPDATE_POLICY(id),
    data,
    true,
    {},
    {},
    axios
  );

const deletePolicy = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_POLICY(id), true, {}, {}, axios);

const getAllGuardRailGroups = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_ALL_GROUPS, true, {}, {}, axios);

const createGroup = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_GROUP, data, true, {}, {}, axios);

const getAllGroupWithPolicies = async (): Promise<any> =>
  APIManager.sendGet(
    GuardrailsEnds.GET_ALL_GROUP_WITH_POLICIES,
    true,
    {},
    {},
    axios
  );

const deleteGroup = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_GROUP(id), true, {}, {}, axios);

const getMCPProxy = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_MCP_PROXY, true, {}, {}, axios);

const getAllTools = async (serverId: string): Promise<any> =>
  APIManager.sendGet(
    GuardrailsEnds.GET_ALL_TOOLS(serverId),
    true,
    {},
    {},
    axios
  );

// servers
const getserverList = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_ALL_SERVERS, true, {}, {}, axios);

const createServer = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_SERVER, data, true, {}, {}, axios);

const updateServer = async (id: string, data: any): Promise<any> =>
  APIManager.sendPatch(
    GuardrailsEnds.UPDATE_SERVER(id),
    data,
    true,
    {},
    {},
    axios
  );

const createTool = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_TOOL, data, true, {}, {}, axios);

const deleteTool = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_TOOL(id), true, {}, {}, axios);

const deleteServer = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_SERVER(id), true, {}, {}, axios);

// api-keys
const getApiKeys = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_API_KEYS, true, {}, {}, axios);

const createApiKey = async (data: any): Promise<any> =>
  APIManager.sendPost(GuardrailsEnds.CREATE_API_KEY, data, true, {}, {}, axios);

const updateApiKey = async (id: string, data: any): Promise<any> =>
  APIManager.sendPatch(
    GuardrailsEnds.UPDATE_API_KEY(id),
    data,
    true,
    {},
    {},
    axios
  );

const deleteApiKey = async (id: string): Promise<any> =>
  APIManager.sendDelete(GuardrailsEnds.DELETE_API_KEY(id), true, {}, {}, axios);

const getAllProxy = async (): Promise<any> =>
  APIManager.sendGet(GuardrailsEnds.GET_PROXY_SETTINGS, true, {}, {}, axios);

const updateProxySettings = async (data: any): Promise<any> =>
  APIManager.sendPatch(
    GuardrailsEnds.UPDATE_PROXY_SETTINGS,
    data,
    true,
    {},
    {},
    axios
  );

export const GuardrailsService = {
  getAllGuardRail,
  createPackage,
  updatePackage,
  deletePackage,
  getAllGuardrailsPolicy,
  createPolicy,
  updatePolicy,
  deletePolicy,
  getAllGuardRailGroups,
  createGroup,
  getAllGroupWithPolicies,
  deleteGroup,
  getMCPProxy,
  getAllTools,
  createTool,
  getserverList,
  deleteTool,
  createServer,
  updateServer,
  deleteServer,
  getApiKeys,
  createApiKey,
  updateApiKey,
  deleteApiKey,
  getAllProxy,
  updateProxySettings,
};
